var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'schedule-table', { 'schedule-table--margin': !_vm.settings.removeMargin } ],style:(("--max-height: " + (_vm.settings.maxHeight || '300px')))},[(_vm.openAddModal)?_c('modal',{key:_vm.openAddModal,attrs:{"form":{
            class: 'schedule-table__modal'
        },"customSettings":{
            class: 'schedule-table__modal__content',
            position: 'center',
            color: 'green',
            button: {
                label: 'confirm',
                type: 'submit',
                action: function () {
                    _vm.closeAddSchedule(),
                    _vm.addToSchedule()
                }
            }
        }},on:{"close":function($event){return _vm.closeAddSchedule()}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"cblock__modal__header"},[_vm._v(_vm._s(_vm.$t('global.addSchedule')))])]},proxy:true},{key:"modal__body__confirm",fn:function(){return [_c('base-field',{staticClass:"schedule-table__day",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.day') },
                        input: {
                            component: 'InputAutocomplete',
                            id: 'weekday',
                            name: 'weekday',
                            type: 'text',
                            value: '',
                            targetClass: 'field__input--default typography--default color--default',
                            isRequired: _vm.$route.meta.isAdd,
                            browserAutocomplete: 'off',
                            dynamicData: {
                                data: _vm.daysDrop
                            }
                        },
                        allowFilling: true
                    }}}),_c('div',{staticClass:"display--flex schedule-table__add-inputs"},[_c('base-field',{staticClass:"campaign__body__edate",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.startsAt') },
                        input: {
                            component: 'InputTimeSelector',
                            name: 'startsAt',
                            id: 'startsAt',
                            targetClass: 'field__input--default typography--default color--default',
                            value: _vm.startValue,
                            browserAutocomplete: 'off'
                        },
                        allowFilling: true
                    }},model:{value:(_vm.startValue),callback:function ($$v) {_vm.startValue=$$v},expression:"startValue"}}),_c('base-field',{staticClass:"campaign__body__edate",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.endsAt') },
                        input: {
                            component: 'InputTimeSelector',
                            name: 'endsAt',
                            id: 'endsAt',
                            targetClass: 'field__input--default typography--default color--default',
                            value: _vm.endValue,
                            browserAutocomplete: 'off'
                        },
                        allowFilling: true
                    }},model:{value:(_vm.endValue),callback:function ($$v) {_vm.endValue=$$v},expression:"endValue"}})],1)]},proxy:true},{key:"modal__info",fn:function(){return [_c('base-button',{staticClass:"modal__content__button--negative background--transparent border--grey",domProps:{"innerHTML":_vm._s(_vm.$t('global.cancel'))},on:{"click":function($event){$event.preventDefault();_vm.closeAddSchedule(); _vm.contactValue = null; _vm.blockBarAndResetPayload()}}})]},proxy:true}],null,false,1855839714)}):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.list.length)?_c('div',{staticClass:"table--with-results",attrs:{"aria-label":"table"}},[_vm._l((_vm.schedule),function(row,index){return _c('div',{key:index,staticClass:"schedule-table__body scroll",class:[
                'schedule-table__body__row display--flex',
                { 'schedule-table__body__row--color': row.id % 2 === 0 && row.id !== 0 }
            ],attrs:{"role":"rowgroup"}},[_c('span',{staticClass:"schedule-table__body__row__weekday"},[_vm._v(" "+_vm._s(row.weekday)+" ")]),_c('div',{staticClass:"schedule-table__body__row__time--container display--flex"},_vm._l((row.schedules),function(time,indexFieldY){return _c('span',{key:indexFieldY,staticClass:"schedule-table__body__row__time pointer",on:{"click":function($event){_vm.openEditModal = true;
                        _vm.startValue = time.startsAt;
                        _vm.endValue = time.endsAt;
                        _vm.timeId = time.id;
                        _vm.interruptMessageFunction();}}},[_vm._v(" "+_vm._s(time.startsAt)+" - "+_vm._s(time.endsAt)+" ")])}),0)])}),(_vm.openEditModal)?_c('modal',{key:_vm.openEditModal,attrs:{"form":{
                class: 'schedule-table__modal'
            },"customSettings":{
                class: 'schedule-table__modal__content',
                position: 'center',
                color: 'green',
                button: {
                    label: 'confirm',
                    type: 'submit',
                    action: function () {
                        _vm.openEditModal = false,
                        _vm.addToPayload( _vm.timeId )
                    }
                }
            }},on:{"close":function($event){_vm.openEditModal = false}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"cblock__modal__header"},[_vm._v(_vm._s(_vm.$t('global.editSchedule')))])]},proxy:true},{key:"modal__body__confirm",fn:function(){return [_c('div',{staticClass:"display--flex"},[_c('base-field',{staticClass:"campaign__body__edate",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.startsAt') },
                            input: {
                                component: 'InputTimeSelector',
                                name: 'startsAt',
                                id: 'startsAt',
                                targetClass: 'field__input--default typography--default color--default',
                                value: _vm.startValue,
                                browserAutocomplete: 'off',
                            },
                            isEdition: _vm.isEdition,
                            allowFilling: true
                        }},model:{value:(_vm.startValue),callback:function ($$v) {_vm.startValue=$$v},expression:"startValue"}}),_c('base-field',{staticClass:"campaign__body__edate",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.endsAt') },
                            input: {
                                component: 'InputTimeSelector',
                                name: 'endsAt',
                                id: 'endsAt',
                                targetClass: 'field__input--default typography--default color--default',
                                value: _vm.endValue,
                                browserAutocomplete: 'off',
                            },
                            isEdition: _vm.isEdition,
                            allowFilling: true
                        }},model:{value:(_vm.endValue),callback:function ($$v) {_vm.endValue=$$v},expression:"endValue"}})],1)]},proxy:true},{key:"modal__info",fn:function(){return [_c('base-button',{staticClass:"background--transparent color--red border--red",attrs:{"type":"submit"},domProps:{"innerHTML":_vm._s(_vm.$t('global.remove'))},on:{"click":function($event){_vm.openEditModal = false; _vm.removeSchedule( _vm.timeId )}}})]},proxy:true}],null,false,3198188343)}):_vm._e()],2):_c('div',{staticClass:"schedule-table--without-results"},[_vm._v(_vm._s(_vm.$t('global.noRecordsFound', { type: _vm.settings.warning} )))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }